import { render } from "./Page24.vue?vue&type=template&id=443959c3&scoped=true"
import script from "./Page24.vue?vue&type=script&lang=js"
export * from "./Page24.vue?vue&type=script&lang=js"

import "./Page24.vue?vue&type=style&index=0&id=443959c3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443959c3"]])

export default __exports__